<template>
  <div>
    <div class="tabsTurn">
       <a-tabs v-model="currentTab" @change="handleTabChange" centered>
          <a-tab-pane key="0" tab="待审核" />
          <a-tab-pane key="1" tab="审核通过" />
          <a-tab-pane key="2" tab="审核驳回" />
          <a-tab-pane key="3" tab="已退款" />
        </a-tabs>
    </div>
        
    <div>
      <div class="table-page-search-wrapper" v-if="hasPerm('buRecipeReturnDrug:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="医师姓名">
                <a-input v-model="queryParam.drName" allow-clear placeholder="请输入医师姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="患者姓名">
                <a-input v-model="queryParam.patientName" allow-clear placeholder="请输入患者姓名"/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="处方编号">
                  <a-input v-model="queryParam.recipeId" allow-clear placeholder="请输入处方编号"/>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    <a-card :bordered="false">

      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <!-- <template class="table-operator" slot="operator" v-if="hasPerm('buRecipeReturnDrug:add')" >
          <a-button type="primary" v-if="hasPerm('buRecipeReturnDrug:add')" icon="plus" @click="$refs.addForm.add()">新增处方退药</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('buRecipeReturnDrug:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button>
          <x-down
            v-if="hasPerm('buRecipeReturnDrug:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template> -->
        <span  slot="category" slot-scope="text, record"> 
            {{record.category == '1'? '西药/中成药' : record.category == '2'? '中药处方' : '' }}
        </span>
        <span slot="patientsex" slot-scope="text, record">
          {{record.patientsex == '1'? '男' : '女' }}
        </span>
  
        <span slot="returnDrugStatus" slot-scope="text, record">
          {{(record.returnDrugStatus == '0' || record.returnDrugStatus == '3') ? '待审核' : (record.returnDrugStatus == '1'|| record.returnDrugStatus == '4') ? '审核通过' : (record.returnDrugStatus == '2' || record.returnDrugStatus == '5') ? '审核驳回' :  record.returnDrugStatus == '6' ? '已退费' :'' }}
        </span>
        <span slot="returnStockStatus" slot-scope="text, record">
          {{ record.returnStockStatus == '0' ? '未退'  : record.returnStockStatus == '1' ? '已退'  : ''}}
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="clickDetial(record, false)" v-if="record.returnDrugStatus == '0' || record.returnDrugStatus == '3'" style="margin-right:5px">审核</a>
          <a @click="clickDetial(record, true)"  v-if="record.returnDrugStatus == '1'|| record.returnDrugStatus == '4' || record.returnDrugStatus == '2' || record.returnDrugStatus == '5' || record.returnDrugStatus == '6'" style="margin-right:5px">详情</a>
          <a @click="clickReturn(record)"  v-if="record.returnDrugStatus == '2' || record.returnDrugStatus == '5'" style="margin-right:5px">驳回原因</a>
          <!-- <a v-if="hasPerm('buRecipeReturnDrug:edit')" @click="$refs.editForm.edit(record)">编辑</a> -->
          <!-- <a-divider type="vertical" v-if="hasPerm('buRecipeReturnDrug:edit') & hasPerm('buRecipeReturnDrug:delete')"/> -->
          <a-popconfirm v-if="record.returnDrugStatus == '1'|| record.returnDrugStatus == '4'" placement="topRight" title="确认退款？" @confirm="() => singleRefund(record)">
            <a>确认退款</a>
          </a-popconfirm>


        </span>
      </s-table>
      <!-- <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" /> -->
      <add-form-xi ref="addFormXi" @ok="handleOk" />
      <add-form-zhong ref="addFormZhong" @ok="handleOk" />

      <a-modal v-model="weight" title="驳回原因" :footer="null">
      <a-row :gutter="24">
        <a-col :md="20">
          <div style="line-height: 23px;">
            <span v-if="rejectReturnDrugTime" style="font-size: 13px;">{{ rejectReturnDrugTime }}</span>
            <div v-if="rejectReturnDrugReason">{{ rejectReturnDrugReason }}</div>
            <div v-if="secondRejectReturnDrugTime"  style="font-size: 13px; margin-top: 10px;">{{ secondRejectReturnDrugTime }}</div>
            <div v-if="secondRejectReturnDrugReason">{{ secondRejectReturnDrugReason }}</div>
          </div>
        </a-col>
      </a-row>
    </a-modal>

    </a-card>
    </div>

  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import {  buRecipeReturnDrugDelete, buRecipeReturnDrugExport, recipeReturnDrugPage, recipeReturnDrugRefund,recipeReturnDrugDetial } from '@/api/modular/interhospital/burecipereturndrug/buRecipeReturnDrugManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  import addFormXi from './addFormXi.vue'
  import addFormZhong from './addFormZhong.vue'

  export default {
    components: {
      STable,
      addForm,
      editForm,
      addFormXi,
      addFormZhong,
      XDown
    },
    data () {
      return {
        weight: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '处方编号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '处方类型',
            align: 'center',
            dataIndex: 'category',
            scopedSlots: { customRender: 'category' },
          },
          {
            title: '患者姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'patientage'
          },
          {
            title: '科室',
            align: 'center',
            dataIndex: 'deptName'
          },
          {
            title: '就诊医师',
            align: 'center',
            dataIndex: 'drRealName'
          },
          {
            title: '审核状态',
            align: 'center',
            dataIndex: 'returnDrugStatus',
            scopedSlots: { customRender: 'returnDrugStatus' },
          },
          {
            title: '库存',
            align: 'center',
            dataIndex: 'returnStockStatus',
            scopedSlots: { customRender: 'returnStockStatus' },
          },
          {
            title: '提交时间',
            align: 'center',
            dataIndex: 'createTime'
          },
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          let obj = {status: this.currentTab}
          return recipeReturnDrugPage(Object.assign(parameter, this.switchingDate(),obj)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        currentTab: '0',
        rejectReturnDrugReason: '',
        rejectReturnDrugTime: '',
        secondRejectReturnDrugReason: '',
        secondRejectReturnDrugTime: ''
      }
    },
    created () {
      if (this.hasPerm('buRecipeReturnDrug:edit') || this.hasPerm('buRecipeReturnDrug:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      handleTabChange(key) {
        console.log('切换tabs页',key)
        this.currentTab = key
        this.$refs.table.refresh()
      },
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamrejectTime = this.queryParam.rejectTimeDate
        if (queryParamrejectTime != null) {
            this.queryParam.rejectTime = moment(queryParamrejectTime).format('YYYY-MM-DD')
            if (queryParamrejectTime.length < 1) {
                delete this.queryParam.rejectTime
            }
        }
        const queryParamsecondRejectTime = this.queryParam.secondRejectTimeDate
        if (queryParamsecondRejectTime != null) {
            this.queryParam.secondRejectTime = moment(queryParamsecondRejectTime).format('YYYY-MM-DD')
            if (queryParamsecondRejectTime.length < 1) {
                delete this.queryParam.secondRejectTime
            }
        }
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      
       /**
       * 单个退款
       */
       singleRefund (record) {
        this.recipeReturnDrugRefund({recipeId: record.id })
      },
      
      recipeReturnDrugRefund (record) {
        recipeReturnDrugRefund(record).then((res) => {
          if (res.success) {
            this.$message.success('退款成功')
            this.handleOk()
            // this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('退款失败') // + res.message
          }
        })
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.buRecipeReturnDrugDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.buRecipeReturnDrugDelete(paramIds)
      },
      buRecipeReturnDrugDelete (record) {
        buRecipeReturnDrugDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      onChangerejectTime(date, dateString) {
        this.rejectTimeDateString = dateString
      },
      onChangesecondRejectTime(date, dateString) {
        this.secondRejectTimeDateString = dateString
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        buRecipeReturnDrugExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 点击查看详情
      clickDetial(record , isShow) {
        if (record.category == 1) {
          this.$refs.addFormXi.add(record, isShow)
        } else {
          this.$refs.addFormZhong.add(record, isShow)
        }
      },
      // 驳回原因
      clickReturn(record) {
        this.record = record;
        this.weight = true;
        let params = {
          pageNo: 1,
          pageSize: 10,
          id: record.id
        }
        recipeReturnDrugDetial(params).then(res => {
          if (res.code == 200) {
            const {rejectReturnDrugReason, rejectReturnDrugTime,secondRejectReturnDrugReason,secondRejectReturnDrugTime} = res.data
            this.rejectReturnDrugReason = rejectReturnDrugReason;
            this.rejectReturnDrugTime = rejectReturnDrugTime ? this.formatDate(rejectReturnDrugTime) : '';
            this.secondRejectReturnDrugReason = secondRejectReturnDrugReason;
            this.secondRejectReturnDrugTime = secondRejectReturnDrugTime ? this.formatDate(secondRejectReturnDrugTime) : '';
          } 
        })

      },
      handleWeight() {
        this.weight = false;
      },
      formatDate(d) {
        var date = new Date(d);
        var YY = date.getFullYear() + '-';
        var MM =
          (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1) + '-';
        var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var hh =
          (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm =
          (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
          ':';
        var ss =
          date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return YY + MM + DD + ' ' + hh + mm + ss;
      },

    }
  }
</script>
<style lang="less">

  .tabsTurn{
    background: #fff;
    padding-left: 16px;
    padding-top: 16px
  }
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }

  .ant-card-body{
    padding: 0px 24px 24px;
  }
  .table-page-search-wrapper{
    background: #fff;
    padding: 20px 16px 0px;
  }
</style>
